'use strict';

import angular from  "angular";
import "angular-cookies";
import "angular-resource";

export default angular.module('fastx.Api',['ngResource', 'ngCookies'])
.factory('Api',['$resource','$http','$cookies', function($resource, $http,$cookies){
	function responseWasSuccessful(data){
		return data.hasOwnProperty('result');
	}

	function get(uri,params,success,error){
		success = success || function(d){};
		error   = error   || function(e){};
		$resource(uri,params,{
			headers: {
				"X-XSRF-TOKEN": $cookies.get ('xsrf-token')
			}}).get(function(d){
			if(responseWasSuccessful(d)){
				var a = JSON.parse(angular.toJson(d.result));
				success(a);
			}else{
				error(d);
			}
		},function(e){
			error(e)
		});
	}
	function post(uri,params,body,success,error){
		success = success || function(d){};
		error   = error   || function(e){};
		$http({
			method: "POST",
			url: uri,
			data: body,
			headers: {
				"X-XSRF-TOKEN": $cookies.get ('xsrf-token')
			}})
			.then (function(res) {
				var d = res.data;
				if(responseWasSuccessful(d)){
					success(JSON.parse(angular.toJson(d.result)));
				}else{
					error(d);
				}
			})
			.catch (function (e){
				error({
					error:{
						code:e.status,
						message:e.statusText
					}
				});
			});
	}
	function remove(uri,params,success,error){
		success = success || function(d){};
		error   = error   || function(e){};
		$resource(uri,params,{
			headers: {
				"X-XSRF-TOKEN": $cookies.get ('xsrf-token')
			}}).remove(function(d){
			if(responseWasSuccessful(d)){
				success(JSON.parse(angular.toJson(d.result)));
			}else{
				error(d);
			}
		},function(e){
			error({
				error:{
					code:e.status,
					message:e.statusText
				}
			});
		});
	}
	return {
		get:get,
		post:post,
		remove:remove
	}
}]);



//////////////////
// WEBPACK FOOTER
// ../common/Api.js
// module id = 2
// module chunks = 0